import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LanguageIcon from "@mui/icons-material/Language";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import { type MouseEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { VISIBLE_LANGUAGES } from "@/i18n/constants";
import logo from "@/logo.svg";
import { colors } from "@/theme/colors";

export const HEADER_HEIGHT = 60;

export function Header() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleOpen = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = (code?: string) => {
    if (code) void i18n.changeLanguage(code);
    setAnchorEl(null);
  };

  const currentLabel = VISIBLE_LANGUAGES.find((l) => l.code === i18n.language)?.label ?? "English";

  return (
    <AppBar
      position="static"
      elevation={0}
      className="guest-header"
      sx={{
        height: HEADER_HEIGHT,
        flex: "none",
        bgcolor: "primary.main",
        boxShadow: "0 2px 8px rgba(39,35,57,.2)",
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: HEADER_HEIGHT,
          height: HEADER_HEIGHT,
          px: { xs: 2, sm: 3, md: 4 },
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* ロゴ */}
        <Box
          component="img"
          src={logo}
          alt="JapanTicket PRESTIGE"
          sx={{
            height: { xs: 26, sm: 30 },
          }}
        />

        <Box sx={{ flex: 1 }} />

        {/* 言語選択プルダウン */}
        <Button
          onClick={handleOpen}
          aria-haspopup="menu"
          aria-expanded={menuOpen}
          startIcon={<LanguageIcon sx={{ fontSize: 18 }} />}
          endIcon={
            <KeyboardArrowDownIcon
              sx={{
                fontSize: 18,
                transform: menuOpen ? "rotate(180deg)" : "none",
                transition: "transform .2s",
              }}
            />
          }
          sx={{
            textTransform: "none",
            color: colors.headerText,
            fontSize: { xs: 13, sm: 14 },
            fontWeight: 500,
            borderRadius: "8px",
            "&:hover": { bgcolor: "rgba(255,255,255,.1)" },
          }}
        >
          {currentLabel}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={() => handleClose()}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          slotProps={{
            paper: {
              sx: {
                minWidth: 160,
                borderRadius: "10px",
                border: `1px solid ${colors.borderSoft}`,
                boxShadow: "0 8px 24px rgba(39,35,57,.18)",
              },
            },
          }}
        >
          {VISIBLE_LANGUAGES.map((lang) => (
            <MenuItem
              key={lang.code}
              selected={lang.code === i18n.language}
              onClick={() => handleClose(lang.code)}
              sx={{
                borderRadius: "6px",
                fontSize: 14,
                fontWeight: lang.code === i18n.language ? 700 : 400,
                "&.Mui-selected": { bgcolor: colors.borderSoft, color: colors.text },
                "&:hover": { bgcolor: colors.borderSoft },
              }}
            >
              {lang.label}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
